import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        header: 'toggleSection',
      },
    };

    this.speed = parseFloat(this.getData('speed') || 1);
  }

  init() {
    if (this.getData('open')) {
      this.openSection(this.$('section')[0]);
    }
  }

  openSection(section) {
    const wrapper = this.$('main', section)[0];
    section.classList.add('is-open');

    gsap.to(wrapper, {
      maxHeight: wrapper.children[0].scrollHeight,
      duration: this.speed,
      ease: 'power2.out',
      onComplete: () => {
        this.call('resize', 'Scroll');
      },
    });
  }

  closeSection(section) {
    const wrapper = this.$('main', section)[0];
    section.classList.remove('is-open');

    gsap.to(wrapper, {
      maxHeight: 0,
      duration: this.speed,
      ease: 'power2.out',
      onComplete: () => {
        this.call('resize', 'Scroll');
      },
    });
  }

  toggleSection(e) {
    const target = e.currentTarget;
    const section = this.parent('section', target);
    const main = this.$('main', section);

    if (section.classList.contains('is-open')) {
      this.closeSection(section);
    } else {
      let openedSection = this.$('section.is-open')[0];
      if (openedSection) {
        this.closeSection(openedSection);
      }
      this.openSection(section);
    }
  }
}
